function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M885.34 319.07l-258-3.8-102.7-264.4c-19.8-48.801-88.899-48.801-108.6 0l-102.7 264.4-258 3.8c-53.4 3.101-75.1 70.2-33.7 103.9l209.2 181.4-71.3 247.7c-14 50.899 41.1 92.899 86.5 65.899l224.3-122.7 224.3 122.6c45.4 27 100.5-15 86.5-65.9l-71.3-247.7 209.2-181.4c41.399-33.7 19.7-100.8-33.7-103.8z"
});

var SvgStar = function SvgStar(props) {
  return React.createElement("svg", _extends({
    fill: "currentColor",
    width: 21,
    height: 21,
    viewBox: "0 0 940.69 940.69"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJjdXJyZW50Q29sb3IiIHZlcnNpb249IjEuMSIgd2lkdGg9IjIxIiBoZWlnaHQ9IjIxIiB2aWV3Qm94PSIwIDAgOTQwLjY5IDk0MC42OSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im04ODUuMzQgMzE5LjA3LTI1OC0zLjgtMTAyLjctMjY0LjRjLTE5LjgtNDguODAxLTg4Ljg5OS00OC44MDEtMTA4LjYgMGwtMTAyLjcgMjY0LjQtMjU4IDMuOGMtNTMuNCAzLjEwMS03NS4xIDcwLjItMzMuNyAxMDMuOWwyMDkuMiAxODEuNC03MS4zIDI0Ny43Yy0xNCA1MC44OTkgNDEuMSA5Mi44OTkgODYuNSA2NS44OTlsMjI0LjMtMTIyLjcgMjI0LjMgMTIyLjZjNDUuNCAyNyAxMDAuNS0xNSA4Ni41LTY1LjlsLTcxLjMtMjQ3LjcgMjA5LjItMTgxLjRjNDEuMzk5LTMzLjcgMTkuNy0xMDAuOC0zMy43LTEwMy44eiIvPgo8L3N2Zz4K";
export { SvgStar as ReactComponent };